import PropTypes from 'prop-types'
import classNames from 'classnames'
import { startCase } from 'lodash'
import { useHistory } from 'react-router'

import transactionHistoryItemUtils from 'components/TransactionHistoryItem/utils'
import { formattedDateByTimeZone } from 'utils/timezone'
import { transactionHistoryStatus } from 'utils/resources'
import { formatPriceDecimals } from 'utils/formatPriceDecimals'

const TransactionHistoryItem = ({ transactionHistory }) => {
  const {
    createdAt,
    status,
    authorizationAmount,
    settlementAmount,
    paymentType,

    id,
  } = transactionHistory

  const history = useHistory()
  const { time, dateWithSlashes } = formattedDateByTimeZone(createdAt)

  const { icon, label } =
    transactionHistoryItemUtils.getTransactionHistoryIconAndLabel(
      transactionHistory
    )

  const creditCardPaymentTypeNumbers = [1, 3, 14, 22, 28, 29, 30]
  const isDetailedPaymentInformation =
    creditCardPaymentTypeNumbers.includes(paymentType)

  const onClickDetailedPaymentInformation = () => {
    const transactionHistoryId = id

    history.push(
      `${window.location.pathname}/payment-details/${transactionHistoryId}`
    )
  }

  return (
    <section className="transaction-history-item">
      <div className="transaction-history-item__info-row">
        <div className="transaction-history-item__title -bold">
          <div>{icon}</div>
          <div className="transaction-history-item__icon-label">{label} </div>
        </div>
        <div className="transaction-history-item__value">
          {dateWithSlashes}, {time}
        </div>
      </div>
      <div className="transaction-history-item__info-row">
        <div className="transaction-history-item__title">
          Transaction Status
        </div>
        <div className="transaction-history-item__value">
          <span
            className={classNames([
              'transaction-history-item__dot',
              `-dot-${transactionHistoryStatus[status]}`,
            ])}
          ></span>
          {startCase(status)}
        </div>
      </div>
      <div className="transaction-history-item__info-row">
        <div className="transaction-history-item__title">
          Authorization Amount
        </div>
        <div className="transaction-history-item__value">
          {formatPriceDecimals(authorizationAmount)}
        </div>
      </div>
      <div className="transaction-history-item__info-row">
        <div className="transaction-history-item__title">Settlement Amount</div>
        <div className="transaction-history-item__value">
          {formatPriceDecimals(settlementAmount)}
        </div>
      </div>
      {isDetailedPaymentInformation && (
        <button
          className="transaction-history-item__vertical-button"
          onClick={onClickDetailedPaymentInformation}
        >
          <span className="transaction-history-item__vertical-button-label">
            Detailed Payment Information
          </span>
        </button>
      )}
      <span
        className={classNames('transaction-history-item__border-break', {
          '-mt-0': isDetailedPaymentInformation,
        })}
      ></span>
    </section>
  )
}

TransactionHistoryItem.propTypes = {
  transactionHistory: PropTypes.shape({
    createdAt: PropTypes.string,
    status: PropTypes.string,
    authorizationAmount: PropTypes.string,
    settlementAmount: PropTypes.string,
    paymentType: PropTypes.number,
    creditCardDetails: PropTypes.shape({
      freedompayIssuerName: PropTypes.string,
      last4: PropTypes.string,
      issuerName: PropTypes.string,
      maskedCardNumber: PropTypes.string,
      accountNumberMasked: PropTypes.string,
    }),
    paymentTypeDisplayName: PropTypes.string,
    id: PropTypes.number,
  }),
}

export default TransactionHistoryItem
